<template>
    <div>
        <app-data-table
            v-if="!!tableData"
            :fields="fields"
            :items="tableData.data"
            :from="tableData.from"
            :to="tableData.to"
            :current-page="tableData.current_page"
            :last-page="tableData.last_page"
            :total="tableData.total"
            :per-page="tableData.per_page"
            :on-change-page="onChangePage"
            @sort="onSort"
        >
            <template slot="actions" slot-scope="{ item }">  
                <app-form-select-input
                    :options="administratives"
                    @change="administrativeId => saveAssignment(administrativeId,item.id)"
                >
                </app-form-select-input>
            </template>
        </app-data-table>
        <b-alert show v-else>Esperando datos...</b-alert>
        <b-row class="justify-content-center">
            <b-col>
                <b-spinner v-if="saving" style="width: 3rem; height: 3rem;" class="padre" label="Loading..."></b-spinner>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    props: {
        tableData: {
            type: [Array, Object],
            default: '',
        },
        administratives: {
            type: [Array, Object]
        },
        evaluationId: {
            type: Number
        },
        onChangePage: {
            type: Function,
            required: true,
        },
    },
    computed:{
        ...mapGetters(['currentEvaluation']),
    },
    data: () => ({
        fields,
        saving: false
    }),
    methods: {
        async saveAssignment(administrativeId,guardId){
            if(administrativeId){
                this.saving = true
                const {data} = await repo.post('evaluation-users/store-operational-user-assignment',{
                administrativeId: administrativeId,
                guardId: guardId,
                evaluationId: this.currentEvaluation.id
            })
                if(data.status){
                    this.saving = false
                    toastr.success(data.msg)
                }else{
                    this.saving = false
                    toastr.error('Ocurrió un error al asignar')
                }
            }
        },
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}
const fields = [
    {
        key: 'name',
        label: 'Nombre',
    },
    {
        key: 'actions',
        label: 'Administrativos',
    },
]
</script>
<style scoped>
    .padre {
        text-align: center;
        position: absolute;
        margin-left: 46%;
        margin-top: -62%;
    }
</style>
